module.exports = __webpack_public_path__ + "img/logoUjedVertical.dae206cc.png";